import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { SettingsService } from '../../../core/http/settings.service';

@Component({
  selector: 'app-card-modal',
  templateUrl: './card-modal.component.html',
  styleUrls: ['./card-modal.component.scss']
})
export class CardModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  cards = null;


  constructor(private modal: ModalService, public auth: SettingsService) { }

  ngOnInit(): void {

    this.auth
      .getCard()
      .subscribe(
        (resSuccess) => {

          this.cards = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      ); 
  }

}
